/* Event Type client data model
 *
 * Angular Module: trackerbase-app.models
 * Injected Factory: EventType
 */

import makePropsEnumerable from "../utility/MakePropsEnumerable";

const mEventTypeId = new WeakMap();
const mEventTypeName = new WeakMap();
const mEventTypeDescription = new WeakMap();

class EventType {
    constructor(etId, etName, etDescription) {
        if (etId > 0) {
            mEventTypeId.set(this, etId);
        }
        else {
            throw new TypeError("Invalid Event Type Id");
        }

        if (etName == null) {
            mEventTypeName.set(this, null);
        }
        else {
            mEventTypeName.set(this, etName.toString());
        }

        mEventTypeDescription.set(this, etDescription);
    }

    get eventTypeId() {
        return mEventTypeId.get(this);
    }

    set eventTypeId(eId) {
        if (Number.IsInteger(eId) && (eId > 0)) {
            mEventTypeId.set(this, eId);
        }
    }

    get eventTypeName() {
        return mEventTypeName.get(this);
    }

    set eventTypeName(etName) {
        if ((etName == null) ||
            (typeof etName === "string")) {
            mEventTypeName.set(this, etName);
        }
    }

    get eventTypeDescription() {
        return mEventTypeDescription.get(this);
    }

    set eventTypeDescription(eDescription) {
        mEventTypeDescription.set(this, eDescription);
    }

    toString() {
        return `${this.eventTypeName} (${this.eventTypeId})`;
    }

    valueOf() {
        return this.eventTypeId;
    }

    hasDescription() {
        return ((this.eventTypeDescription != null) &&
        (this.eventTypeDescription.length > 0));
    }

    static Copy(otherEventType) {
        if (otherEventType != null)
        {
            return new EventType(
                otherEventType.eventTypeId,
                otherEventType.eventTypeName,
                otherEventType.eventTypeDescription
            );
        }
        else {
            throw new TypeError(
                "EventType Copy Factory requires defined, non-null source"
            );
        }
    }

    static FromServerEventType(serverEventType) {
        return new EventType(
            serverEventType.EventTypeId,
            serverEventType.EventTypeName,
            serverEventType.Description
        );
    }
}

makePropsEnumerable(EventType.prototype, [
    "eventTypeId",
    "eventTypeName",
    "eventTypeDescription",
    "valueOf",
    "hasDescription"
]);

export default EventType;



//////////////////
// WEBPACK FOOTER
// ./src/models/EventType.js
// module id = 0ZTF
// module chunks = 1